




















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatMMMDateString } from "@/shared/dateString";
import { truncate } from "lodash";
import { Claim, ClaimType, HsabExpenseFormMode, HsabExpenseFormType, CombinedClaimReceiptStatus } from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { claimTypeIcon } from "@/shared/awesomeIconMapper";
import { useClaimStore } from "@/employee/store/claim";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useThemeStore } from "@/shared/store/theme";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
@Component({
  components: {
    HsabExpenseReimbursementStatusPill,
    Pill,
    Button,
    CurrencyAmount,
  },
})
export default class HsabImportedClaimRow extends Vue {
  truncate = truncate;
  formatMMMDateString = formatMMMDateString;
  claimTypeIcon = claimTypeIcon;
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  claimStore = useClaimStore();
  @Prop() claim: Claim;
  @Prop() hideLinkAndCreateFeatures: boolean;
  @Prop() index: number;
  @Prop() forceSmallScreen: boolean;

  ClaimType = ClaimType;

  get additionalProviders (): string {
    if (this.claim.providersCount > 1) {
      const additionalProviders = this.claim.providersCount - 1;
      return `(+${additionalProviders})`;
    }
    else {
      return "";
    }
  }
  get isAlt (): boolean {
    return this.index % 2 === 0;
  }
  get hasLinkedExpenses () {
    return this.claim.linkedExpenseIds
      && this.claim.linkedExpenseIds.length > 0;
  }
  get hasAmount (): boolean {
    return this.claim.memberResponsibility > 0;
  }
  async handleCardRowClick (event: UIEvent) {
    if (!this.claim.memberResponsibility) {
      return;
    }
    this.claimStore.loadLinkedHsabExpenses(this.claim.claimNumber);
    this.hsabExpenseFormStore.loadTalonClaim(this.claim);
    if (this.hasLinkedExpenses) {
      await this.hsabExpenseFormStore.loadExpenseForViewOrEdit(this.claim.linkedExpenseIds[0]);
    } else {
      this.hsabExpenseFormStore.modalType = HsabExpenseFormType.ExpenseManagement;
      this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
    }
  }
  async handleEditClick (expenseId: number) {
    await this.hsabExpenseFormStore.loadExpenseForViewOrEdit(expenseId);
  }
  get expenseFormModalMode () {
    return this.hsabExpenseFormStore.modalMode;
  }
  statusText (hasLinkedExpenses: boolean, status: CombinedClaimReceiptStatus) {
    if (hasLinkedExpenses) {
      return status;
    }
    else return CombinedClaimReceiptStatus.Available;
  }
}
